import { useCallback, useEffect, useState } from "react";

import { obtenerCatalogoModelos } from "../api/client";
import type { CatalogoModelos } from "../api/types";

// Puebla los selectores de modelo/effort desde GET /api/v1/models -- fuente
// unica de aliases (restriccion vinculante: prohibido hardcodear un modelo).

export interface EstadoModelos {
  catalogo: CatalogoModelos | null;
  cargando: boolean;
  error: string | null;
  recargar: () => void;
}

export function useModelos(): EstadoModelos {
  const [catalogo, setCatalogo] = useState<CatalogoModelos | null>(null);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [intento, setIntento] = useState(0);

  useEffect(() => {
    let cancelado = false;
    setCargando(true);
    obtenerCatalogoModelos()
      .then((datos) => {
        if (cancelado) return;
        setCatalogo(datos);
        setError(null);
      })
      .catch((err) => {
        if (cancelado) return;
        setError(
          err instanceof Error
            ? err.message
            : "No se pudo cargar el catalogo de modelos.",
        );
      })
      .finally(() => {
        if (!cancelado) setCargando(false);
      });
    return () => {
      cancelado = true;
    };
  }, [intento]);

  const recargar = useCallback((): void => setIntento((n) => n + 1), []);

  return { catalogo, cargando, error, recargar };
}
